import { Link } from "react-router-dom";
import logo from '../assets/logo.svg';

const HeaderStatic = ({ color }) => {
  return (
    <div className={`header-small center-children bg bg-color-${color} bg-image-white`}>
      <Link to="/">
        <img src={logo} className="logo-small" alt="logo" />
      </Link>
    </div>
  );
};

export default HeaderStatic;
